const account = {
    accountInformation: 'Accountinformatie',
    emailAddress: 'E-mailadres',
    username: 'Gebruikersnaam',
    yourPlan: 'Jouw Plan',
    about: 'Over Mij',
    aboutDescription: 'Ik ben een fantastische klant.',
    creditsRemaining: 'Resterende credits',
    buyMoreUpgrade: 'Koop Meer/Upgrade',
    manageSubscription: 'Abonnement Beheren',
    logout: 'Uitloggen',
    logoutConfirmation: 'Bevestig Uitloggen',
    logoutConfirmMessage: 'Weet je zeker dat je wilt uitloggen?',
    deleteAccount: 'Account Verwijderen',
    deleteAccountConfirmation: 'Weet je zeker dat je je account wilt verwijderen?',
    deleteAccountWarning: 'Deze actie kan niet ongedaan worden gemaakt. Al je gegevens worden permanent verwijderd.',
    deleteAccountButton: 'Verwijder Mijn Account',
    deleteAccountInputPlaceholder: 'Type "delete" om te bevestigen',
    deleteAccountInputError: 'Type "delete" om accountverwijdering te bevestigen',
    deleteAccountPasswordPlaceholder: 'Voer je wachtwoord in',
    deleteAccountPasswordRequired: 'Wachtwoord is verplicht',
    changePassword: 'Wachtwoord Wijzigen',
    changePasswordDescription: 'Werk je accountwachtwoord bij',
    currentPassword: 'Huidig Wachtwoord',
    newPassword: 'Nieuw Wachtwoord',
    confirmNewPassword: 'Bevestig Nieuw Wachtwoord',
    passwordChanged: 'Wachtwoord succesvol gewijzigd',
    passwordChangeError: 'Fout bij wijzigen wachtwoord',
    currentPasswordWrong: 'Huidig wachtwoord is onjuist',
    passwordChangedRedirect: 'Wachtwoord succesvol gewijzigd. Je wordt doorgestuurd naar inloggen.',
    socialLoginNoPassword: 'Dit profiel is gemaakt via Google-inlog en heeft geen wachtwoord om te wijzigen.',
    accountDeactivated: 'Account gedeactiveerd',
    accountReactivated: 'Account succesvol geheractiveerd',
    // Address form
    personalAddress: 'Persoonlijk Adres',
    address: 'Adres',
    city: 'Stad',
    postalCode: 'Postcode',
    country: 'Land',
    phone: 'Telefoon',
    edit: 'Bewerken',
    add: 'Toevoegen',
    save: 'Opslaan',
    saving: 'Opslaan...',
    addressUpdated: 'Adres succesvol bijgewerkt',
    addressUpdateError: 'Fout bij bijwerken adres',
    noAddressData: 'Geen adresinformatie beschikbaar',
    cancel: 'Annuleren',
    confirm: 'Bevestigen'
};

export default account;

